// extracted by mini-css-extract-plugin
export default {"modify":"Modify_modify__1tEdB"};